/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CartItem } from './CartItem';
import {
    CartItemFromJSON,
    CartItemFromJSONTyped,
    CartItemToJSON,
} from './CartItem';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { Voucher } from './Voucher';
import {
    VoucherFromJSON,
    VoucherFromJSONTyped,
    VoucherToJSON,
} from './Voucher';

/**
 * 
 * @export
 * @interface Cart
 */
export interface Cart {
    /**
     * 
     * @type {Array<CartItem>}
     * @memberof Cart
     */
    items?: Array<CartItem>;
    /**
     * 
     * @type {Array<Voucher>}
     * @memberof Cart
     */
    vouchers?: Array<Voucher>;
    /**
     * 
     * @type {Price}
     * @memberof Cart
     */
    totalAmount?: Price;
}

/**
 * Check if a given object implements the Cart interface.
 */
export function instanceOfCart(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CartFromJSON(json: any): Cart {
    return CartFromJSONTyped(json, false);
}

export function CartFromJSONTyped(json: any, ignoreDiscriminator: boolean): Cart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(CartItemFromJSON)),
        'vouchers': !exists(json, 'vouchers') ? undefined : ((json['vouchers'] as Array<any>).map(VoucherFromJSON)),
        'totalAmount': !exists(json, 'totalAmount') ? undefined : PriceFromJSON(json['totalAmount']),
    };
}

export function CartToJSON(value?: Cart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : ((value.items as Array<any>).map(CartItemToJSON)),
        'vouchers': value.vouchers === undefined ? undefined : ((value.vouchers as Array<any>).map(VoucherToJSON)),
        'totalAmount': PriceToJSON(value.totalAmount),
    };
}

